// use the same type as https://createjs.com/docs/preloadjs/files/preloadjs_data_Types.js.html#
export const Types = {
    IMAGE: "image",
    JAVASCRIPT: "javascript",
    JSON: "json",
    SOUND: "sound",
    TEXT: "text",
    VIDEO: "video",
};
//# sourceMappingURL=createjs.js.map